import { render, staticRenderFns } from "./membersDetails.vue?vue&type=template&id=428de60c&"
import script from "./membersDetails.vue?vue&type=script&lang=js&"
export * from "./membersDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports